import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import Select from 'react-select';
import {fixLangFlag} from './utils';

class LocaleSelectField {
    static initLocaleSelectField() {
        const domContainer = document.querySelector('.locale-select-field');
        if (domContainer) {
            const field = $(domContainer);
            let options = field.data('options');
            let defaultValue = {
                value: 'auto',
                label: 'Auto'
            };
            let valueFromData = field.data('value');

            _.forOwn(options, function (locale, key) {
                if (locale.value === valueFromData) {
                    defaultValue = locale;
                }
                options[key].label = <div className='react-select__single-value--row'>
                    <span className={'iti-flag lang-flag lang-flag--' + (fixLangFlag(locale.value)) + ' ' + (fixLangFlag(locale.value))}></span>{locale.label}
                </div>;
            });

            ReactDOM.render(
                <Select
                    defaultValue={defaultValue}
                    options={options}
                    name={field.data('name')}
                    id={field.data('id')}
                    classNamePrefix='react-select'
                    className={field.data('class')}
                />,
                domContainer
            );
        }
    }
}

LocaleSelectField.initLocaleSelectField();
